import { CloseIcon } from '@chakra-ui/icons'
import { Button, Text } from '@chakra-ui/react'
import React from 'react'

export const EditorCloseButton = ({ onClose }: { onClose: () => void }) => (
  <Button
    gap={1}
    ml="auto"
    variant="outline"
    bg="whiteAlpha.600"
    color="gray.500"
    size="xs"
    onClick={onClose}>
    <CloseIcon w={2} h={2} />
    <Text lineHeight={1}>CLOSE</Text>
  </Button>
)
